import React, { PropsWithChildren } from "react";
//#region types
import { PanelWithDividerProps } from "models/propTypes/panelsPropsTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const PanelWithDivider: React.FC<PropsWithChildren<PanelWithDividerProps>> = ({ title, children }) => {
  return (
    <Grid item container rowGap={2} direction="column" className={cssExports.panelWithDivider} alignItems="flex-start">
      <Grid item container className={cssExports.panelWithDividerHeaderText}>
        {title}
      </Grid>
      {children}
    </Grid>
  );
};

export default PanelWithDivider;
